import React from "react";
import DatePicker from "react-datepicker";

export const ChangeStartDate = ({
  msg,
  okButtonShow,
  okButtonText,
  okAction,
  cancelButtonShow,
  cancelButtonText,
  closeAction,
  handleDate,
  minStartDate,
  startDate,
}) => {
    let styles = {
        marginBottom: '20px'
      }
  //Model shows the limit exceed the limit
  return (
    <div className="hoverlay">
      <div className="popup_inner">
        <div className="close_popup">
          <button onClick={closeAction}>X</button>
        </div>
        <div className="popup_content">
          <div className="popup_txt">
            <div style={styles}>{msg}</div>
            <DatePicker
              placeholderText="Select Start Date"
              dateFormat="dd/MM/yyyy"
              minDate={minStartDate}
              selected={startDate? startDate: Date.now()}
              onSelect={handleDate}
            />
          </div>
          <div className="popup_footer">
            {cancelButtonShow && (
              <button onClick={closeAction}>{cancelButtonText}</button>
            )}
            {okButtonShow && <button onClick={okAction}>{okButtonText}</button>}
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./web/components/campaign/ChangeDate.jsx